// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"EnterLeaveRequestSummary_sectionHeader__mgeNt","link":"EnterLeaveRequestSummary_link__1IUcy"};